const getters = {
  sidebar: state => state.app.sidebar,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  keepAliveRoute: state => state.tagsView.keepAliveRoute,
  username: state => state.user.username,
  token: state => state.user.token,
  id: state => state.user.id,
  menuIds: state => state.user.menuIds,
  sideBarMenu: state => state.user.sideBarMenu,
  isAllRole: state => JSON.parse(state.user.isAllRole)
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js